import React from "react";

import Footer from "../index/Footer.jsx";

class RoygbivPrivacy extends React.Component {
  render() {
    return (
      <>
        <main ref='main'>
          <div className='container'>
            <h2>ROY G. BIV Privacy Policy</h2>
            <p>
              ROY G. BIV is a narrative video game developed by Morph Studios,
              a Qmulo, Inc. company. It is designed to be
              played anonymously: there are no accounts, no sign-in, and we do
              not collect your name, email address, or any other personal
              identifying information.
            </p>

            <h3>Information We Collect</h3>
            <h5>Leaderboard scores (optional)</h5>
            <p>
              If you choose to submit a score to a leaderboard, the display
              name you enter and your score are sent to our servers so they can
              appear on the leaderboard. The name is whatever you type — it
              does not need to identify you.
            </p>
            <h5>Gameplay analytics and crash reports</h5>
            <p>
              The app uses Unity Analytics to collect standard gameplay
              telemetry — things like level progression, session length, and
              device model — to help us understand how the experience is
              played. If the app crashes, a crash report including technical
              details about your device and the error is sent through Unity's
              crash reporting service. This data is statistical and diagnostic;
              it is not used to identify or profile you.
            </p>

            <h3>Device Permissions</h3>
            <p>
              <strong>Camera</strong> is used to power the game's augmented
              reality features. The camera feed is processed on your device and is
              never recorded or uploaded. <strong>Microphone</strong> is used
              for in-game audio visualization, processed entirely on your
              device. <strong>Location</strong>, if granted, is used only to
              render realistic lighting and shadows in AR scenes — your
              location is not stored, tracked, or sent to our servers. All
              permissions are optional and can be revoked in your device
              settings.
            </p>

            <h3>Third-Party Services</h3>
            <p>
              ROY G. BIV relies on{" "}
              <a href='https://unity.com/legal/privacy-policy'>
                Unity Technologies
              </a>{" "}
              (analytics and crash reporting) and{" "}
              <a href='https://policies.google.com/privacy'>
                Google Cloud Storage
              </a>{" "}
              (delivery of downloadable game content). The app contains no
              advertising networks, no in-app purchases, and no social media
              integrations, and we do not use advertising identifiers or sell
              any data.
            </p>

            <h3>Children's Privacy</h3>
            <p>
              ROY G. BIV does not require or knowingly collect personal
              information from anyone, including children.
            </p>

            <h3>Links to Other Sites</h3>
            <p>
              The game may open links to external sites, such as music
              streaming platforms. These external sites are not operated by
              us, and we advise you to review their privacy policies. We have
              no control over and assume no responsibility for the content,
              privacy policies, or practices of any third-party sites or
              services.
            </p>

            <h3>Changes to This Privacy Policy</h3>
            <p>
              We may update our Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page. These changes are effective immediately after they are
              posted on this page.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have any questions or suggestions about our Privacy
              Policy, contact us at{" "}
              <a href='mailto:support@morphxr.app'>support@morphxr.app</a> or{" "}
              <a href='mailto:contact@morphxr.io'>contact@morphxr.io</a>.
            </p>

            <p>Last Updated 08/28/2026</p>
          </div>
        </main>

        <Footer />
      </>
    );
  }
}

export default RoygbivPrivacy;
